import { render, staticRenderFns } from "./IconLike.vue?vue&type=template&id=de9f6774&"
import script from "./IconLike.vue?vue&type=script&lang=js&"
export * from "./IconLike.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports